// src/components/DashboardTile.jsx
import React from 'react';

export default function DashboardTile({ title, children }) {
  return (
    <div className="backdrop-blur-md bg-white bg-opacity-20 dark:bg-opacity-10 p-6 rounded-2xl shadow-lg">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">{title}</h2>
      <div className="text-gray-700 dark:text-gray-200">
        {children}
      </div>
    </div>
  );
}